import React from 'react';
import styles from './user_hero.module.scss';
import {CustomerAccountType} from '../../../gql/customer/graphql.ts';
import {__} from '../../../support/lang/translations.ts';
import {Avatar} from '../../../components/avatar/avatar.tsx';
import {CustomerFieldKeys, getValue} from '../../../support/get_data.ts';
import {Size} from '../../../enums/size.ts';

interface OwnProps {
    customerAccount?: CustomerAccountType | null;
    children?: React.ReactNode;
}

export function UserHero({customerAccount, children}: OwnProps) {
    const name = getValue(customerAccount?.customer, CustomerFieldKeys.NAME)?.value;
    const pictureUrl = customerAccount?.customer?.profilePicture?.signed_url;

    return (
        <div className={styles.user_hero}>
            <div className={styles.hero_user}>
                {customerAccount && (
                    <h1 className={styles.hero_title}>
                        {__('dashboard.titles.welcome.greeting')}
                        <br />
                        {name ?? ''}
                    </h1>
                )}

                <Avatar name={name ?? ''} src={pictureUrl} editable={false} size={Size.Medium} />

                <h2 className={styles.hero_subtitle}>{__('dashboard.titles.welcome.nice_day')}</h2>
            </div>

            {children}
        </div>
    );
}
